module.exports = __webpack_public_path__ + "resources/images/inplannen_img-3-23bb316934195ff26cd59de5725dffdd-cache.jpg";